<div class="p-4">
  <!-- Header -->
  <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6">
    <div>
      <h2 class="text-2xl font-bold text-gray-800">Gestión de Aprobadores</h2>
      <p class="text-gray-500 mt-1">Administra los usuarios autorizados para aprobar documentos en cada módulo</p>
    </div>
    <button (click)="openNewDialog()"
      class="mt-3 sm:mt-0 inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors shadow-sm">
      <i class="pi pi-plus mr-2"></i>
      Nuevo Aprobador
    </button>
  </div>

  <!-- Loading -->
  <div *ngIf="isLoading" class="flex justify-center items-center py-12">
    <i class="pi pi-spin pi-spinner text-4xl text-blue-500"></i>
  </div>

  <!-- Error -->
  <div *ngIf="loadError && !isLoading"
    class="bg-red-50 border border-red-200 rounded-lg p-6 text-center">
    <i class="pi pi-exclamation-triangle text-3xl text-red-500 mb-2"></i>
    <p class="text-red-700">Error al cargar los aprobadores</p>
    <button (click)="loadApprovers()" class="mt-3 text-blue-600 hover:text-blue-800 underline">
      Reintentar
    </button>
  </div>

  <!-- Empty state -->
  <div *ngIf="!isLoading && !loadError && approvers.length === 0"
    class="bg-gray-50 border border-gray-200 rounded-lg p-8 text-center">
    <i class="pi pi-users text-4xl text-gray-400 mb-3"></i>
    <p class="text-gray-600 text-lg">No hay aprobadores registrados</p>
    <p class="text-gray-400 mt-1">Agrega el primer aprobador haciendo clic en "Nuevo Aprobador"</p>
  </div>

  <!-- Table -->
  <div *ngIf="!isLoading && !loadError && approvers.length > 0" class="bg-white rounded-lg shadow overflow-hidden">
    <table class="min-w-full divide-y divide-gray-200">
      <thead class="bg-gray-50">
        <tr>
          <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
          <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nombre</th>
          <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Módulo</th>
          <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Estado</th>
          <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Notas</th>
          <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Acciones</th>
        </tr>
      </thead>
      <tbody class="bg-white divide-y divide-gray-200">
        <tr *ngFor="let approver of approvers" class="hover:bg-gray-50 transition-colors">
          <td class="px-6 py-4 whitespace-nowrap">
            <div class="flex items-center">
              <i class="pi pi-envelope text-gray-400 mr-2"></i>
              <span class="text-sm font-medium text-gray-900">{{ approver.email }}</span>
            </div>
          </td>
          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{{ approver.fullName || '-' }}</td>
          <td class="px-6 py-4 whitespace-nowrap">
            <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
              {{ getModuleLabel(approver.module) }}
            </span>
          </td>
          <td class="px-6 py-4 whitespace-nowrap">
            <span *ngIf="approver.isActive"
              class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
              <i class="pi pi-check-circle mr-1" style="font-size: 0.65rem;"></i> Activo
            </span>
            <span *ngIf="!approver.isActive"
              class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-600">
              <i class="pi pi-minus-circle mr-1" style="font-size: 0.65rem;"></i> Inactivo
            </span>
          </td>
          <td class="px-6 py-4 text-sm text-gray-500 max-w-xs truncate">{{ approver.notes || '-' }}</td>
          <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
            <button (click)="openEditDialog(approver)"
              class="text-blue-600 hover:text-blue-900 mr-3" title="Editar">
              <i class="pi pi-pencil"></i>
            </button>
            <button (click)="confirmDelete(approver)"
              class="text-red-600 hover:text-red-900" title="Eliminar">
              <i class="pi pi-trash"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Dialog Formulario -->
<p-dialog [header]="isEditing ? 'Editar Aprobador' : 'Nuevo Aprobador'"
  [(visible)]="showFormDialog" [modal]="true" [style]="{ width: '500px' }" [closable]="true">

  <div class="space-y-4 pt-2">
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-1">Email *</label>
      <input type="email" [(ngModel)]="formData.email" pInputText
        class="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        placeholder="correo@ejemplo.com" />
    </div>

    <div>
      <label class="block text-sm font-medium text-gray-700 mb-1">Nombre Completo</label>
      <input type="text" [(ngModel)]="formData.fullName" pInputText
        class="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        placeholder="Nombre del aprobador" />
    </div>

    <div>
      <label class="block text-sm font-medium text-gray-700 mb-1">Módulo *</label>
      <select [(ngModel)]="formData.module"
        class="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
        <option *ngFor="let opt of moduleOptions" [value]="opt.value">{{ opt.label }}</option>
      </select>
    </div>

    <div class="flex items-center">
      <input type="checkbox" [(ngModel)]="formData.isActive" id="isActive"
        class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
      <label for="isActive" class="ml-2 text-sm text-gray-700">Activo</label>
    </div>

    <div>
      <label class="block text-sm font-medium text-gray-700 mb-1">Notas</label>
      <textarea [(ngModel)]="formData.notes" rows="3"
        class="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        placeholder="Notas opcionales..."></textarea>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      <button (click)="closeDialog()" class="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50">
        Cancelar
      </button>
      <button (click)="saveApprover()" [disabled]="isSaving || !formData.email || !formData.module"
        class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed">
        <i *ngIf="isSaving" class="pi pi-spin pi-spinner mr-2"></i>
        {{ isEditing ? 'Actualizar' : 'Crear' }}
      </button>
    </div>
  </ng-template>
</p-dialog>

<!-- Dialog Confirmación de Eliminación -->
<p-dialog header="Confirmar Eliminación" [(visible)]="showDeleteConfirm" [modal]="true"
  [style]="{ width: '400px' }" [closable]="true">
  <div class="text-center py-4">
    <i class="pi pi-exclamation-triangle text-4xl text-amber-500 mb-3"></i>
    <p class="text-gray-700">
      ¿Está seguro de eliminar al aprobador <strong>{{ deletingApprover?.email }}</strong>?
    </p>
    <p class="text-sm text-gray-500 mt-1">Esta acción no se puede deshacer.</p>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      <button (click)="cancelDelete()"
        class="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50">
        Cancelar
      </button>
      <button (click)="deleteApprover()"
        class="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700">
        Eliminar
      </button>
    </div>
  </ng-template>
</p-dialog>
